import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

function RelatedTrackCard({ track }) {
  return (
    <Link
      to={`/track/${track.slug}`}
      className="iw-track-card group relative flex flex-col overflow-hidden"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={track.image}
          alt={track.name}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#11296B]/45 to-transparent" />
        <span className="absolute left-3 top-3 border border-white/30 bg-white/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.22em] text-white backdrop-blur">
          {track.code}
        </span>
      </div>
      <div className="flex flex-1 flex-col justify-between p-6">
        <div>
          <h3 className="font-display text-xl font-semibold tracking-tight text-[color:var(--iw-primary)]">
            {track.name}
          </h3>
          <p className="mt-1 text-sm text-[color:var(--iw-accent-red)]">
            {track.tagline}
          </p>
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-[color:var(--iw-border)] pt-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[color:var(--iw-primary)] group-hover:text-[color:var(--iw-accent-red)]">
            Enter the Track
          </span>
          <ArrowUpRight className="h-4 w-4 text-[color:var(--iw-primary)] group-hover:text-[color:var(--iw-accent-red)]" />
        </div>
      </div>
    </Link>
  );
}

export default function RelatedTracksGrid({ tracks }) {
  if (!tracks?.length) return null;

  return (
    <section className="border-b border-[color:var(--iw-border)] bg-[color:var(--iw-bg)] py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-10 flex items-end justify-between">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[color:var(--iw-primary)] sm:text-4xl">
            Explore other tracks
          </h2>
          <Link
            to="/#tracks"
            className="hidden font-mono text-[11px] uppercase tracking-[0.22em] text-[color:var(--iw-primary)] hover:text-[color:var(--iw-accent-red)] sm:block"
          >
            View all →
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {tracks.map((track) => (
            <RelatedTrackCard key={track.slug} track={track} />
          ))}
        </div>
      </div>
    </section>
  );
}
